__turbopack_context__.v({
  "container": "L6BlfG_container",
  "item": "L6BlfG_item",
  "nav": "L6BlfG_nav",
  "navBtn": "L6BlfG_navBtn",
  "navBtnLeft": "L6BlfG_navBtnLeft",
  "navBtnRight": "L6BlfG_navBtnRight",
  "progress": "L6BlfG_progress",
  "rail": "L6BlfG_rail",
  "thumb": "L6BlfG_thumb",
  "track": "L6BlfG_track",
  "viewport": "L6BlfG_viewport",
});
